import { Box } from "@mui/material";
import QRCode from "qrcode";
import { useEffect, useRef, useState } from "react";

const QR_SIZE_PX = 200;

interface MultiFactorQrCodeProps {
	otpAuthUri: string;
}

const MultiFactorQrCode = ({ otpAuthUri }: MultiFactorQrCodeProps) => {
	const canvasRef = useRef<HTMLCanvasElement | null>(null);
	const [renderError, setRenderError] = useState(false);

	useEffect(() => {
		const canvas = canvasRef.current;
		if (!canvas) return;

		let cancelled = false;
		QRCode.toCanvas(canvas, otpAuthUri, { errorCorrectionLevel: "M", margin: 2, width: QR_SIZE_PX })
			.then(() => {
				if (!cancelled) setRenderError(false);
			})
			.catch(() => {
				if (!cancelled) setRenderError(true);
			});

		return () => {
			cancelled = true;
		};
	}, [otpAuthUri]);

	return (
		<Box sx={{ display: renderError ? "none" : "block", height: QR_SIZE_PX, width: QR_SIZE_PX }}>
			<canvas ref={canvasRef} />
		</Box>
	);
};

export default MultiFactorQrCode;
